__gh__webApp.articlePage 			= __gh__webApp.articlePage || {};
__gh__webApp.articleExtLoginPage 	= __gh__webApp.articleExtLoginPage || {};

var __gh__articlePage_fullArticleCount 	= 0;
	__gh__articlePage_articleLoaded		= false;



/*
|--------------------------------------------------------------------------
| Article: Init
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.init = function(){

    var utilities 	= __gh__webApp.utilities,
		ads			= __gh__webApp.ads;
		
		utilities["3rdPartyIframes"].init();

	$(document).ready(function () {
		var articlePage 		= __gh__webApp.articlePage,
			articleExtLoginPage	= __gh__webApp.articleExtLoginPage,
			currentPage			= __gh__webApp.currentPage;

			articlePage.fetchArticle.init();

			articlePage.bindEvents();
			articlePage.relatedLinksHandler.init();

		__gh__webApp.comments.viafoura.init();
		__gh__webApp.social.twitter.init();
		
		if(currentPage.isArticleExtLogin()){
			articleExtLoginPage.init();
		}

	});
};









/*
|--------------------------------------------------------------------------
| Article: Bind Events
|--------------------------------------------------------------------------
*/

/**
 * Contains Bind Events for article page
 */
__gh__webApp.articlePage.bindEvents = function(){


	/**
	 * History API Popstate Event Listener
	 * Will only fire for a "popstate" event - https://github.com/browserstate/history.js/issues/47#issuecomment-25750285
	 */
	 History.Adapter.bind(window,'statechange',function(){
		 
		/*	SCROLL DOESN'T WORK SMOOTHLY - THINK I NEED TO DISABLE AND ENABLE WAYPOINT DURING SCROLL

			var commonJS		= __gh__webApp.common,
			currentIndex 	= History.getCurrentIndex(),
			state 			= History.getState(),
		 	internal 		= (state.data._index == (currentIndex - 1)),
			data  			= state.data,
			articlePage		= data.articleDOM + " .scroll-page[data-page="+data.page+"]";
		if (!internal && !commonJS.isObjectEmpty(data)) {
			alert("articleDOM:"+articlePage);
			$('html, body').animate({
			    "scrollTop": $(articlePage).offset().top
			},"fast");
		}*/
	});

};





/*
|--------------------------------------------------------------------------
| Article: Article Ads
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.articleAds = {


	/**
	 * Inject ads
	 * @param {object} options
	 * @param {object} options.articleObject - Article object
	 * @param {string} options.articleDOM - Article container DOM
	 */
	"injectAds": function(articleDOM,articleObject){
		var $allGraphs 			= $(articleDOM+' .article-body p:not(.article-summary,table p),'+articleDOM+' .article-body div.related,'+articleDOM+' .article-body .article-block'),
			firstAdGraph		= 2,
			$firstAdGraph		= $allGraphs[firstAdGraph],
			adOffset			= 5,
			$startingGraph		= $allGraphs[(adOffset-1)],
			totalGraphs			= $allGraphs.length,
			adFrequency			= 7,
			totalAds			= Math.floor((totalGraphs-adOffset)/adFrequency);


		//Inject first ad
		if($firstAdGraph){
			var adObj = {},
				html  = __gh__webApp.utilities.fetch.handlebarsView.get({
					"view":"buckets/partials/ads/_medRecBaseArticle","data":{keywords:articleObject.keywords}
				});
			$allGraphs.eq(firstAdGraph).before(html);
		}


		if(!$startingGraph && (totalGraphs < adFrequency)){return;}

		for(var i=0;i<totalAds;i++){
			var start 			= ((((i+1) * adFrequency) + adOffset) - adFrequency),
				end				= (start-1) + adFrequency,
				injectionPoint	= end - (adFrequency/2),
				relCheck		= false;

			for(var ii=start;ii<end;ii++){
				var graph = ii-1;
				if(relCheck){continue;}
				if($allGraphs.eq(graph).hasClass('related')){relCheck = true;}
				if((ii+1)==end){
					var adObj = {},
						html  = __gh__webApp.utilities.fetch.handlebarsView.get({
							"view":"buckets/partials/ads/_medRecLazyArticle","data":{keywords:articleObject.keywords}
						});
					$allGraphs.eq(graph).before(html);
				}
			}
		}
	}
};

















/*
|--------------------------------------------------------------------------
| Article: Load Article
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.loadArticle = {

	/**
	 * Callbacks that are run when an article is loaded.  Used for the bucket laydown and read more links that are clicked.
	 * @param {object} options
	 * @param {object} options.articleObject - Article object
	 * @param {string} options.articleDOM - Article container DOM
	 */
	"callbacks": function(options){
		var articleObject 	= (options.articleObject) 	? options.articleObject : {},
			articleDOM		= (options.articleDOM) 		? options.articleDOM 	: null,
			trackArticle	= __gh__webApp.utilities.tracker.trackArticle,
			utilities 		= __gh__webApp.utilities,
			ads				= __gh__webApp.ads,
			articlePage		= __gh__webApp.articlePage,
			comments		= __gh__webApp.comments,
			analytics		= __gh__webApp.analytics;
		
		$(articleDOM).attr("data-article-object", '{"guid": "'+articleObject.guid+'"}');
		
		articlePage.relatedContent.injectRelatedContent({"articleDOM":articleDOM,"relatedContentObject":articleObject.relatedContent});
	
		articlePage.articleAds.injectAds(articleDOM,articleObject);


		if(__gh__adsLoaded){
			var k = 'article keywords';
			ads.dfp.buildKruxCatlist(k,articleObject.keywords);
			analytics.krux.refreshData();
		}
		ads.init();
	
		articlePage.stickyMeta.init(articleDOM);
	
		// add third party callbacks here
		comments.viafoura.reset();
		
		trackArticle.allArticlesOnLoad({"articleObject":articleObject});
	
	
		articlePage.articleURLHandler.addScrollListeners(articleDOM,articleObject);

		//For Viafoura social hub widget. Call viafoura ideacloud js if .ideacloud div is present.
		if ($(".ideacloud")[0]){
			__gh__webApp.common.loadScript({"src":"http://portal.ideacloud.me/embed/embed.js"});
		}
	
		//REMOVED PAGINATION FOR NOW
		//articlePage.pagination(articleDOM,articleObject);
		
		
	}
};









/*
|--------------------------------------------------------------------------
| Article: Consumer Survey
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.consumerSurvey = {
	
	"isSurveyLoaded": function(){
			return $(".t402-elided").length > 0;
	},

	/**
	 * Main survey code was added server side just below the body tag per google's recommendation
	 * This function calls their code
	 */
	"showSurvey": function(articleObject){
		var surveyID = __gh__coreData["3rdPartyData"].analytics.google.consumerSurvey;
		if(__gh__webApp.paywall.isUserLoggedIn() || !surveyID) { return; }
		
		var articleURL 	= window.location.href,
			contentID 	= 'everything';
		
		TriggerPrompt(articleURL,contentID);
	},
	
	
	"showSurveyCallback": function(){
		var consumerSurvey = __gh__webApp.articlePage.consumerSurvey;
		if (consumerSurvey.isSurveyLoaded()){
			__gh__webApp.articlePage.fetchArticle.disableFetch();
		}
	}
};






/*
|--------------------------------------------------------------------------
| Article: Related Content
|--------------------------------------------------------------------------
*/
__gh__webApp.articlePage.relatedContent = {
	"defaults":{
		"frequency": 3,
	},

	"callbacks": function(){
		var utilities 	= __gh__webApp.utilities,
			articlePage = __gh__webApp.articlePage;

		utilities.lazyImages.loadAllImages();
		utilities.googleMap.loadAllMaps();
		utilities.slider.loadAllSliders();
		utilities.showMoreLink.loadAllShowMoreLinks();
	},

	/**
	 * Draws the related content widgets within the article body
	 * @param {object} options
	 * @param {object} options.relatedContent={}
	 */
    "injectRelatedContent" : function (options) {
	    var thisObject				= __gh__webApp.articlePage.relatedContent,
	    	relatedContentObject	= (options.relatedContentObject) ? options.relatedContentObject : {},
	    	manualPlacement			= relatedContentObject.manualPlacement,
			commonJS 				= __gh__webApp.common;

		// Check for Tout
		if(!window.TOUT && commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"video.tout.id")){
			var toutID 	= __gh__coreData["3rdPartyData"].video.tout.id;
			window.TOUT = {
				"propertyUid": toutID,
				"topArticleLoaded": function(e){
					if(e.matchExists){
						if(!manualPlacement){
							options.offsetPlacement = true;
						}
					}
					thisObject.insertRelatedContent(options);
				}
			};
			commonJS.loadScript({"src":"http://platform.tout.com/sdk.js"});
			return;
		}

		thisObject.insertRelatedContent(options);

	},

	/**
	 * Inserts related content into the page
	 */
	"insertRelatedContent": function(options){
		var thisObject 				= __gh__webApp.articlePage.relatedContent,
			commonJS				= __gh__webApp.common,
			articleDOM 				= (options.articleDOM) ? options.articleDOM : null,
	    	relatedContentObject	= (options.relatedContentObject) ? options.relatedContentObject : {},
	    	offsetPlacement			= (options.offsetPlacement)	? options.offsetPlacement : false,
	    	relatedContent			= relatedContentObject.items,
	    	relatedContentDefaults	= relatedContentObject.defaults,
	    	placementObject			= relatedContentObject.placement,
			relatedLinks			= {
				"view": "buckets/article/relatedContent/links",
				"type": "links",
				"items": []
			},
			relatedLinksDefaults	= (commonJS.isObjectPropertySet(relatedContentDefaults,"links.items.main")) ? relatedContentDefaults.links : null,
			relatedContentIndex		= 0,
			commonJS 				= __gh__webApp.common,
			mainImage				= null;
	
		if (relatedContent.length === 0 && !relatedLinksDefaults) {return;}
	
		relatedContent.push(relatedLinks);
		relatedContent = this.sortRelatedContentByPlacement(relatedContent);
	
		//Sort and cleanup placements to remove nodes that don't exist
		relatedContentObject.placement 		= this.sortPlacementObject(placementObject,relatedContent);
		if(offsetPlacement){
			relatedContentObject.placement 	= this.offsetPlacement(placementObject);
		}
	
	
		for (var i=0; i < relatedContent.length; i++) {
			var defaults 			= __gh__webApp.articlePage.relatedContent.defaults,
				type 				= relatedContent[i].type,
				items				= relatedContent[i].items;
	
	
			if(type=="links"){continue;}
	
			//Add main image as the first related image
			if (type =="mainImage"){
				mainImage = items;
				continue;
			}
			if (type =="images"){
				if(mainImage && !commonJS.isArrayEmpty(mainImage)){
					relatedContent[i].items.unshift(mainImage[0]);
				}
				if(commonJS.isArrayEmpty(items)){
					continue;
				}
			}
	
			// If map doesn't have items, skip it.
			if (type=="map" && commonJS.isArrayEmpty(items)){
				continue;
			}
	
			//Build related links
			if (commonJS.isArrayEmpty(items)) {
				relatedLinks.items.push(relatedContent[i]);
				continue;
			}
	
			this.addRelatedContentToPage(relatedContent[i],relatedContentObject,relatedContentIndex,articleDOM);
	
	
			relatedContentIndex++;
		}
	
		// No related links, use defaults
		if (relatedLinks.items.length === 0 && relatedLinksDefaults) {
			relatedLinks = relatedLinksDefaults;
		}
		this.addRelatedContentToPage(relatedLinks,relatedContentObject,relatedContentIndex,articleDOM);
	
		thisObject.callbacks();
	
	},


	/**
	 * Adds related content to the page
	 * Defaults to inserting at every 3 paragraphs unless the editor set manualPlacement to true
	 */
	"addRelatedContentToPage": function(relatedContentItem,relatedContentObject,relatedContentIndex,articleDOM){
		if (relatedContentItem.items.length === 0) {return;}

		relatedContentItem.articleDOM = articleDOM;

		var defaults 			= __gh__webApp.articlePage.relatedContent.defaults,
			fetchHandlebarsView = __gh__webApp.utilities.fetch.handlebarsView,
			manualPlacement		= relatedContentObject.manualPlacement,
			placementObject		= relatedContentObject.placement,
			placement 			= placementObject[relatedContentItem.type],
			paragraphCount 		= (manualPlacement) ? placement : (relatedContentIndex + 1) * defaults.frequency,
			$article 			= $(articleDOM),
			$articleBody 		= $article.find(".article-body"),
			type				= relatedContentItem.type,
			view				= (placement==0 && "featuredView" in relatedContentItem) ? relatedContentItem.featuredView : relatedContentItem.view;
			html 				= fetchHandlebarsView.get({"view":view,"data":relatedContentItem}),
			paragraphIndex		= calculateParagraphIndex(manualPlacement,placement);


		function calculateParagraphIndex(manualPlacement,placement){
			var offset 		= 5,
				frequency	= 3

			if (!manualPlacement){
				return (placement == 1) ? offset : ((placement-1) * frequency) + offset;
			}
			return placement;
		}


		if(type=="mug"){
			$articleBody.find("p:not(.article-summary)").eq(0).before(html);
			return;
		}


		if (placement==0){
			$article.find("h1.headline").after(html);
			return;
		}


		if($articleBody.find("p").not(".related p").eq(paragraphIndex).length == 0){
			$articleBody.append(html);
		} else {
			$articleBody.find("p").not(".related p").eq(paragraphIndex).before(html);
		}

	},


	/**
	 * If there is a tout annatator video for the top of the article and manualPlacement is false
	 * add one to placements
	 */
    "offsetPlacement" : function (placementObject) {
	   for (var key in placementObject){
		  if (key == "mugs"){continue;}
		  placementObject[key]++;
	   }
	   return placementObject;
    },


	/**
	 * Sorts the article objects by placement
	 * @param {array} obj - related content array of objects
	 */
	"sortRelatedContentByPlacement" : function(obj){
		var sortedObj = $.map(obj, function (o) {return [o];}).sort(function (a,b) {return a.placement - b.placement;});
		return sortedObj;
	},


	/**
	 * Sorts a placement object and removes related content nodes that do not exist
	 * https://jsfiddle.net/9puvdznz/1/
	 */
	 "sortPlacementObject": function (placementObj,relatedContent) {

	    //Remove any related content nodes that do not exist in the placement object
		function cleanUpPlacements(placementObj,relatedContent){
	    	var newPlacementObj = {};
	    	for (prop in placementObj) {
				var found = relatedContent.some(function (item) {
	              return item.type === prop;
	            });
	            if (found) {
	               newPlacementObj[prop] = placementObj[prop];
	            }
	      }
	      return newPlacementObj;
	    }


	    //Convert the placements object to an array so that it can be sorted
	  	function convertToArray(obj){
	     var arr = [],
	     		 prop;
	      for (prop in obj) {
	          if (obj.hasOwnProperty(prop)) {
	              arr.push({
	                  'key': prop,
	                  'value': obj[prop]
	              });
	          }
	      }
	      return arr;
	    }


	    //Convert it back to an object to an array and update values
	    function convertToObject(arr){
	    	var newObj 	= {};
	    	for (var i=0; i < arr.length; i++) {
	          newObj[arr[i].key] = i;
	      }
	      return newObj;
	    }


	    var placementObj 	= cleanUpPlacements(placementObj,relatedContent),
	    	arr 			= convertToArray(placementObj);
	       	arr.sort(function(a, b) {
	            return a.value - b.value;
	        });

	    return convertToObject(arr);
	}



};



/*
|--------------------------------------------------------------------------
| Article: Fetch Article
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.fetchArticle = {


	/**
	 * Initialize
	 */
	"init": function() {
		this.bindEvents();
	},


	/**
	 * Get a full article using url, view and dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.url - json data url to fetch
	 * @param {string} options.dom - html dom to insert data
	 * @param {string} options.view - name of handlebars view
	 * @example
	 *	<a href="#"
	 *		data-gh-fetch-article-view="buckets/article/partials/_article"
	 *		data-gh-fetch-article-dom="#gh-fetch-view-{{id}}"
	 *		data-gh-fetch-article-url="{{feedURL}}"
	 *	>{{title}}</a>
	 */
	 "get": function(options){
		var commonJS				= __gh__webApp.common,
			url 					= (options.url) 			? options.url 				: null,
			dom 					= (options.dom) 			? options.dom 				: null,
			view 					= (options.view) 			? options.view 				: null;

		//Check variables
		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing dom."});
			return;
		}
		if(!view){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing view."});
			return;
		}


		//Get JSON
			url 	= commonJS.noCacheURL(url);
		var data 	= {"items": __gh__webApp.utilities.fetch.json.get({"url":url})};
		if(!data.items.main){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Getting the data failed."});
			return;
		}


		//Get View
		var html = __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});
		if(!html){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Getting the view failed."});
			return;
		}


		$(dom).html(html);


		return data.items.main[0];

	},

	/**
	 * Show the full article
	 */
	"showFullArticle": function(readMoreDOM){
		var commonJS			= __gh__webApp.common,
			articlePage			= __gh__webApp.articlePage,
			prependView 		= __gh__webApp.utilities.fetch.handlebarsView.prepend,
			fetchArticle 		= articlePage.fetchArticle,
			trackArticle		= __gh__webApp.utilities.tracker.trackArticle,
			$article			= $(readMoreDOM).parents("article"),
			articleDOM			=  $(readMoreDOM).data("gh-fetch-article-dom"),
			articleObject;

		$(articleDOM).parent().css("position","relative");

		//Inject overlay
		prependView({
			"dom": $(articleDOM).parent(),
			"view": "buckets/articleHalfCard/partials/_loadingOverlay"
		})

		//Scroll to top of article
		$('html, body').animate({
        	scrollTop: $article.offset().top
    	}, 500).promise().then(function() {

			// Load Article
			articleObject = fetchArticle.get({
				"dom"			: articleDOM,
				"url"			: $(readMoreDOM).data("gh-fetch-article-url"),
				"view"			: $(readMoreDOM).data("gh-fetch-article-view")
			});

    	}).promise().then(function(){

			__gh__articlePage_fullArticleCount++;
			$article.attr("data-gh-full-article-counter",__gh__articlePage_fullArticleCount);

	    	__gh__webApp.articlePage.loadArticle.callbacks({"articleObject":articleObject,"articleDOM":articleDOM});

	    	__gh__webApp.social.addToAny.reloadShareButtons();

	    	__gh__webApp.paywall.meterArticle(articleObject.id);
	    	
			History.replaceState(null, articleObject.title, articleObject.link);
			
			trackArticle.readMoreFullArticle({"articleObject":articleObject});
	    	
		}).promise().then(function() {

			// Hide Read more
		    $(readMoreDOM).closest(".halfCard").hide();
		    $article.removeClass("collapsed");

	    }).promise().done(function() {

	    	$article.find(".loading-article-overlay").fadeOut();
	    	__gh__webApp.articlePage.articleURLHandler.refreshScrollListeners();
	    });

	},


	/**
	 * Remove the full articles that are displayed and show the half card instead
	 */
	"removeFullArticles": function(){
		var totalArtsShown 		= __gh__articlePage_fullArticleCount,
			maxArtsToShow		= 1;

		if(totalArtsShown === maxArtsToShow){
			$("[data-gh-full-article-counter]").each(function(){
				var $this 					= $(this),
					$thisCounter 			= $this.attr('data-gh-full-article-counter'),
					$thisFullArtContainer 	= $this.find('.fullArticle'),
					$thisHalfCard			= $this.find('.halfCard');

				if($thisCounter==1){
					$thisHalfCard.show();
					$thisFullArtContainer.html('');
					$this.removeAttr('data-gh-full-article-counter');
					__gh__articlePage_fullArticleCount--;
					$this.addClass("collapsed");
				}
			});

			$("[data-gh-full-article-counter]").each(function(){
				var $this 			= $(this),
					$thisCounter 	= $this.attr('data-gh-full-article-counter');
					$thisCounter--;
				$(this).attr('data-gh-full-article-counter',$thisCounter);
			});
		}

	},


	/**
	 * Bind the UI events
	 */
	"bindEvents": function() {
		var fetchArticle = __gh__webApp.articlePage.fetchArticle;

	    $(document).on("click", "a[data-gh-fetch-article-url]", function(event){
		    var trackReadMoreClick = __gh__webApp.utilities.tracker.trackArticle.readMoreClick;
		    event.preventDefault();
			//fetchArticle.removeFullArticles();
			fetchArticle.showFullArticle(this);
			trackReadMoreClick({
				"label": "Read More",
				"category": "Read More",
				"nonInteraction": true
			});
			//alert("track");
		});
  	},
  	
  	
  	/**
	 * Disable fetch event
	 */
  	"disableFetch": function(){
		$("a[data-gh-fetch-article-url]").removeAttr("data-gh-fetch-article-url");
	}
};









/*
|--------------------------------------------------------------------------
| Article: Pagination
|--------------------------------------------------------------------------
*/

/**
 * Handles Pagination for the article
 *
 */
__gh__webApp.articlePage.pagination = function(articleDOM,articleObject){
	var commonJS		= __gh__webApp.common,
		articleID		= articleDOM.replace("#",""),
		$article		= $(articleDOM),
		isMobile		= __gh__webApp.device.isMobile(),
		scrollPageClass = "scroll-page",
		scrollPageDOM	= articleDOM+" ."+scrollPageClass,
		articleHeight 	= $article.height(),
		pageDepth		= (isMobile) ? 600 : 1000,
		totalPages		= Math.floor(articleHeight/pageDepth);



		$article.css("position","relative");

		//Adds a set of abosolutely positioned divs over the article.  Each div represents a page.
		for (var i = 1; i <= totalPages; i++) {
			$article.find(".scroll-pagination").append("<div class=\"scroll-page\" data-page=\""+i+"\"></div>");
		}
		$(scrollPageDOM).height(pageDepth);



		//Create a waypoint for each article page
		var scrollPages 			= document.getElementById(articleID).getElementsByClassName(scrollPageClass),
			changeArticlePage 		= function(pageNumber){

				var currentPage		= commonJS.getURLParam("page"),
					trackArticle	= __gh__webApp.utilities.tracker.trackArticle;

				if (currentPage == pageNumber || !currentPage && pageNumber == 1){return;}

				var	historyApiURL = commonJS.updateURLParams({
						"url":articleObject.link,
						"params":{"page":pageNumber}
					}),
					pageData = {
		    			"page" : pageNumber,
		    			"articleDOM": articleDOM,
		    			"_index": History.getCurrentIndex()
		    		},
		    		pageTitle = commonJS.getPageTitleWithPageNumber({
			    		"title":articleObject.title,
			    		"pageNumber":pageNumber}
			    	);
					History.replaceState(pageData, pageTitle, historyApiURL);

				trackArticle.pagination({
					"articleObject":articleObject,
					"pageNumber":pageNumber
				});
			};



			for (var i = 0; i < scrollPages.length; i++) {
			  new Waypoint({
			    element: scrollPages[i],
			    handler: function() {
					var	pageNumber 		= this.element.dataset.page;
					changeArticlePage(pageNumber);
			    }
			  });
			}
};









/*
|--------------------------------------------------------------------------
| Article: Sticky Meta
|--------------------------------------------------------------------------
*/

/**
 * Sticky Meta info on scroll
 *
 */
__gh__webApp.articlePage.stickyMeta = {

	"init": function(articleDOM){
		this.bindEvents(articleDOM);
	},

	"bindEvents": function(articleDOM) {

		var $stickyEl = $(articleDOM + ' .article-meta .inner'),
			$stopEl   = $stickyEl.parent().parent().find('.article-body'),
			stickyTop, stopPoint, windowTop;

		if($stickyEl.length) {
			$(window).on('load', function() {
				stickyTop = $stickyEl.offset().top;
			});
			$(window).on('scroll resize', function() {
				if(window.innerWidth >= 768) {
					$stickyEl.parent().css('height',$stopEl.height());

					windowTop = $(window).scrollTop() + $('#toprail').height();
					stickyTop = $stickyEl.parent().offset().top;
					stopPoint = Math.round($stopEl.height() + $stopEl.offset().top - $stickyEl.height());

					if (stickyTop < windowTop && stopPoint > windowTop) {
						$stickyEl.css({'position':'fixed','top':'1em','bottom':'auto','width':$stickyEl.parent().width()});
					} else if(stopPoint - $stickyEl.height() < windowTop) {
						$stickyEl.parent().css('position','relative');
						$stickyEl.css({'position':'absolute','top':'auto','bottom':0});
					} else {
						$stickyEl.parent().css('position','inherit');
						$stickyEl.css({'position':'inherit','width':'auto'});
					}
				} else {
					$stickyEl.css({'position':'inherit','width':'auto'});
				}
			});
		}
	}
};





/*
|--------------------------------------------------------------------------
| Article: Show more/less related links
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.relatedLinksHandler = {
	"init":function(){
		this.bindEvents();
	},
	"handler":{
		relLinkLimit: 3,
		relLiksContainer: '.related-stories',
		relLiksArray: '.related-stories article',
		showMoreLessHTML: '<a href="#" class="expand">Show more <i class="fa fa-caret-down"></i></a>',
		expandBtn: '.related-stories .expand',
		collapseBtn: '.related-stories .collapse',
		showMoreHTML: 'Show more <i class="fa fa-caret-down"></i>',
		showLessHTML: 'Show less <i class="fa fa-caret-up"></i>'
	},
	"expand":function(e){
		var Handler 		= this.handler,
			$this 			= $(Handler.expandBtn),
			$linksArray 	= $(Handler.relLiksArray);

		$this.html(Handler.showLessHTML);
		$this.removeClass('expand');
		$this.addClass('collapse');

		$linksArray.each(function(){$(this).fadeIn();});
	},
	"collapse":function(e){
		var Handler 		= this.handler,
			$this 			= $(Handler.expandBtn),
			$linksArray 	= $(Handler.relLiksArray);

		$this.html(Handler.showMoreHTML);
		$this.addClass('expand');
		$this.removeClass('collapse');

		$linksArray.each(function(i){if(i > (Handler.relLinkLimit-1)){$(this).fadeOut('fast');}});
	},
	"bindEvents":function(){
		var HandlerObject 			= this,
			Handler		 			= HandlerObject.handler,
			$linksArray				= $(Handler.relLiksArray),
			$linksContainer			= $(Handler.relLiksContainer);

		if($linksArray.length > Handler.relLinkLimit){
			$(Handler.showMoreLessHTML).appendTo($linksContainer);
			$linksArray.each(function(i){
				if(i > (Handler.relLinkLimit-1)){
					$(this).hide();
				}
			});
		}
		$(document).on('click', Handler.expandBtn, function(index,element){
			HandlerObject.expand(index);
			index.preventDefault();
		});
		$(document).on('click', Handler.collapseBtn, function(index,element){
			HandlerObject.collapse(index);
			index.preventDefault();
		});
	}
};







/*
|--------------------------------------------------------------------------
| Article: Article URL Handler
|--------------------------------------------------------------------------
*/

/**
 * Update the article url on scroll
 * When exiting a read more article, change back to the main article's url
 * When entering a read more article, change back to that articles url
 */
__gh__webApp.articlePage.articleURLHandler = {
	"refreshScrollListeners": function() {
		Waypoint.refreshAll();
	},
	"addScrollListeners": function (articleDOM,articleObject) {
		var mainArticleObject	= __gh__coreData.pageData.buckets[0].items.main[0];
		
		// Update location bar url
		function updateToMainArticleURL() {
			History.replaceState({}, mainArticleObject.title, mainArticleObject.link);
		}
		function updateToArticleURL() {
			History.replaceState({}, articleObject.title, articleObject.link);
		}
		
		//Top of the article
		new Waypoint({
		  element: $(articleDOM)[0],
		  handler: function(direction) {
			if (direction == "up"){
				updateToMainArticleURL();
				return;	
			}
		  	updateToArticleURL();
		  }
		});
		
		//Bottom of the article
		new Waypoint({
		  element:  $(articleDOM)[0],
		  handler: function(direction) {
		  	if (direction == "down"){
				updateToMainArticleURL();
			  	return;
		  	}
		    updateToArticleURL();
		  },
		  offset:'bottom-in-view'
		});
		
	}
};



/*
|--------------------------------------------------------------------------
| Article Ext Login Page: Init
|--------------------------------------------------------------------------
*/
__gh__webApp.articleExtLoginPage.init = function(){
	var paywall		= __gh__webApp.paywall;
	
	$(document).ready(function() {
		
		paywall.readSession({
			"callback": function(data){
				paywall.toggleLoginLogoutText(data);
				paywall.doWallOnTimer(data);
			}
		});
		
		//disable right click
		$(document).bind("contextmenu",function(e){ 
			return false; 
		});
	});
	
};


// Initialize Article Page
// __gh__webApp.articlePage.init();
